var EF = require('ef/ef');
var utils = require('lib/utils');
var CourseSettingsService = require('services/course-settings-service');
var LocaleService = require('services/locale-service');

var VideoService = function VideoService(){};
VideoService.prototype = _.extend({

  initVideo(videoId, options, callbacks) {
    options = options || {};
    jwplayer.key = 'pnymPx0u6myDbcxnysWJVq5iiBZJZGtVekD/9iU+XjHqxXi0';
    let metadataUrl = "";
    if(options.metadataUrl) {
      metadataUrl = options.metadataUrl;
    } else {
      metadataUrl = utils.coursePath(`video-metadata/${LocaleService.getLanguage()}/${videoId}.json`);
    }

    $.getJSON(metadataUrl).then((metadata) => {
      const playlist = this.buildPlaylist(metadata, options);
      this.buildVideoPlayer(playlist, options);
      this.setupEvents(callbacks);
    });
  },

  buildVideoPlayer(playlist, options){
    const playerConfig = {
      flashplayer: utils.coursePath("javascripts/jwplayer.flash.swf"),
      html5player: utils.coursePath("javascripts/jwplayer.html5.js"),
      playlist: playlist,
      width: options.width || 640,
      height: options.height || 360,
      primary: 'flash',
      mute: EF.enrollment.getData('muted') === 'on',
      abouttext: "EverFi Video",
      aboutlink: "void(0);"
    };

    _.defaults(options, playerConfig);
    this.videoPlayer = jwplayer(options.container).setup( options );
  },

  findLatestTranscode(transcodes){
      transcodes = transcodes.reverse();
      return _.find(transcodes, (t)=> t.Status === "Complete" );
  },

  buildPlaylist(metadata, options){
    const transcode = this.findLatestTranscode(metadata.transcodes);
    if(!transcode){
      return this.localPlaylist(metadata);
    }
    const outputs = _.map(transcode.Outputs, (out)=> out.Key);
    const playlistHLS = transcode.Playlists[0];
    const mediaHost = options.customMediaHost ? CourseSettingsService.get('custom_media_host') : CourseSettingsService.get('media_host');
    const mediaPrefix = `${mediaHost}/${transcode.OutputKeyPrefix}`;

    var playlist = {
      sources: [],
      image: mediaPrefix + '/still-00001.png'
    };
    const hifiThumbPresets = [
      "1435844190196-fskiwc", //720p
      "1435844113001-17zhv3", //720p
      "1435844261521-ym4hbg" //480p
    ];
    const thumbOutput = _.find(transcode.Outputs, (out)=> {
      return hifiThumbPresets.indexOf(out.PresetId) > -1;
    });

    if(thumbOutput && thumbOutput.ThumbnailPattern){
      // Default to second frame, otherwise take option frame thumbnail
      const thumbnail_frame = options.thumbnail_frame.toString();
      const thumnbnail      = '00000'.slice(0,-thumbnail_frame.length) + thumbnail_frame;
      playlist.image        = `${mediaPrefix}${thumbOutput.ThumbnailPattern.replace('{count}', thumnbnail)}.png`;
    }

    playlist.sources.push({
      file: `${mediaPrefix}playlist.m3u8`
    });

    var hdAlternatives = [ '720p', '1080p' ];
    const nonHLSOutputs = _.without(outputs, ...playlistHLS.OutputKeys);
    _.each(nonHLSOutputs, (output)=>{
      playlist.sources.push({
          file: `${mediaPrefix}${output}`
      });
    });

    if(metadata.captions.exist){
      this.hasCaptions = true;
      playlist.tracks = [
        {
          file: mediaPrefix + "captions-en.vtt",
          kind: "captions",
          "default": false
        }
      ];
    }
    return [playlist];
  },

  localPlaylist(metadata){
    return [
      {
        file: `/videos/${LocaleService.getLanguage()}/${metadata.source.base}`
      }
    ];
  },

  setupEvents(callbacks){
    this.seeking = false;
    this.videoPlayer.on('ready', _.bind(this.onReady, this));
    this.videoPlayer.on('play', callbacks.play);
    this.videoPlayer.on('pause', callbacks.pause);
    this.videoPlayer.on('seek', _.bind(this.onSeek, this));
    this.videoPlayer.on('time',_.bind(this.onTime, this));
    this.videoPlayer.on('complete', callbacks.end);
    this.videoPlayer.on('volume', (e)=> this.toggleMute(e.volume === 0) );
    this.videoPlayer.on('mute', (e)=> this.toggleMute(e.mute) );
  },

  toggleMute(muted){
    Chaplin.mediator.publish('media:mute:change', muted ? 'on' : 'off');
  },
  toggleCaptions(){
    if (this.videoPlayer.getCurrentCaptions() === 0) {
      this.videoPlayer.setCurrentCaptions(1);
    } else {
      this.videoPlayer.setCurrentCaptions(0);
    }
  },

  onReady(){
    this.trigger('ready');
  },

  onTime(e) {
    this.trigger('time', e);
  },

  onSeek(e) {
    if (!EF.options.local) {
      if (!this.seeking && e.offset > e.position) {
        this.seeking = true;
        var self = this;
        setTimeout(function () {
          self.videoPlayer.seek(e.position);
        }, 50);
      } else {
        this.seeking = false;
      }
    }
  },
  stop(){
    if (this.videoPlayer) {
      this.videoPlayer.stop();
    }
  },

  play() {
    if (this.videoPlayer) {
      this.videoPlayer.play(true);
    }
  },

  pause() {
    if (this.videoPlayer){
      this.videoPlayer.pause(true);
    }
  },

  mute () {
    if (this.videoPlayer) {
      this.prevVolume = this.videoPlayer.getVolume();
      this.videoPlayer.setVolume(0);
    }
  },

  unmute () {
    if (this.videoPlayer) {
      this.videoPlayer.setVolume(this.prevVolume || 50);
    }
  },

  getState(){
    if(this.videoPlayer){
      return this.videoPlayer.getState().toUpperCase();
    }
  },

  getPosition() {
    if(this.videoPlayer) {
      return this.videoPlayer.getPosition();
    }
  },

  getDuration() {
    if(this.videoPlayer) {
      return this.videoPlayer.getDuration();
    }
  },

  seek(position) {
    if( position < 0 || position > this.getDuration()) return;
    if(this.videoPlayer) {
      this.videoPlayer.seek(position);
    }
  },

  getMute(){
    if(this.videoPlayer){
      return this.videoPlayer.getMute();
    }
  },

  setMute(mute){
    if(this.videoPlayer){
      this.videoPlayer.setMute(mute);
    }
  },

  increaseVolume(amount){
    if (this.videoPlayer){
      this.videoPlayer.setVolume(this.videoPlayer.getVolume() + amount);
    }
  },

  decreaseVolume(amount){
    if (this.videoPlayer){
      this.videoPlayer.setVolume(this.videoPlayer.getVolume() - amount);
    }
  },

  dispose(){
    if (this.videoPlayer) {
      this.videoPlayer.on('ready', () => this.videoPlayer.remove());
    }
  }
}, Backbone.Events);

module.exports = VideoService;
